<template>
  <div class="d-flex align-center">
    <span class="v-label theme--light" style="width: 90px">{{ label }}</span>
    <div
      :style="{
        backgroundColor: color,
        borderRadius: '4px',
        height: '30px',
        width: '30px',
        border: '0.5px rgba(0, 0, 0, 0.12) solid',
        transition: 'border-radius 200ms ease-in-out',
        display: 'inline-flex',
      }"
      @click="openColorPicker"
      class="ml-2 mr-2"
    >
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        absolute
        :position-x="positionX"
        :position-y="positionY"
      >
        <v-card>
          <v-card-text class="pa-0">
            {{ color["hex"] }}
            <v-color-picker
              v-model="color"
              flat
              show-swatches
              hide-mode-switch
              mode="hexa"
              hide-inputs
              :disabled="disabled"
            />
          </v-card-text>
        </v-card>
      </v-menu>
    </div>
    <span class="v-label theme--light" style="width: 100px" v-if="disabled">{{
      color.toUpperCase()
    }}</span>
    <v-text-field
      v-else
      v-model="color"
      dense
      style="width: 100px"
      hide-details
    ></v-text-field>
  </div>
</template>
<script>
import { computed, ref } from "@vue/composition-api";
export default {
  props: {
    label: String,
    parentPortalConfigurationColor: String,
    disabled: Boolean,
  },
  setup(props, { emit }) {
    /* Computed */
    var color = computed({
      get: () => {
        return props.parentPortalConfigurationColor;
      },
      set: (value) => {
        emit("update:parentPortalConfigurationColor", value);
      },
    });

    /* Variables */
    const menu = ref(false);
    const positionX = ref(0);
    const positionY = ref(0);

    /* Méthodes */
    const openColorPicker = function (e) {
      e.preventDefault();
      if (!props.disabled) {
        menu.value = true;
        positionX.value = e.clientX;
        positionY.value = e.clientY;
      }
    };

    return {
      color,
      menu,
      openColorPicker,
      positionX,
      positionY,
    };
  },
};
</script>
<style scoped>
.v-text-field >>> .v-input__append-inner {
  cursor: pointer;
}
</style>
